import React from 'react';
import { UIKitTranslatorProvider } from './TranslatorProvider';
export const UIKitProvider = ({ children, locale, translations, }) => (React.createElement(UIKitTranslatorProvider, { locale: locale, customTranslations: translations }, children));
